module.exports = __webpack_public_path__ + "static/media/arrow-back.1de97615.svg";